// extracted by mini-css-extract-plugin
export default {"main":"ComoConoceSelector_main__naVGe"};